/* eslint-disable local-rules/scoped-modules */
import * as externalModule from './external';
const MEEGO_CORE_MODULE_KEY = '__MEEGO_CORE_MODULE__';

declare global {
  interface Window {
    [MEEGO_CORE_MODULE_KEY]: Record<string, any>;
  }
}

const init = () => {
  window[MEEGO_CORE_MODULE_KEY] = externalModule;

  // window[MEEGO_CORE_MODULE_KEY] = import(
  //   /* webpackChunkName: "core-external" */
  //   './external'
  // );
};

export { init };
